import { CompanyEdit, ICompanyEdit } from "./companyEdit";
import { ICompanyPageList, CompanyPageList } from "./companyPageList";

export interface ICompanyPage {
    list: ICompanyPageList;
    edit: ICompanyEdit;
}

export class CompanyPage implements ICompanyPage {
    list: CompanyPageList;
    edit: CompanyEdit;

    constructor();
    constructor(obj: ICompanyPage);
    constructor(obj?: any) {
        this.list = new CompanyPageList(obj && obj.list || null);
        this.edit = new CompanyEdit(obj && obj.edit || null);
    }
}